import {Component} from 'react'
import connect from 'react-redux/es/connect/connect'
import { isEmpty } from '../../../../shared/services/lodashInJS.js'
import { toPositiveIntString } from '../../../../shared/services/searchService.js'

import {generate} from '../../../routes.js'
import mustHaveAcceptedCGU from '../../../components/Must/MustHaveAcceptedCGU.jsx'
import conf from '../../../conf.js'
import SearchContainer from '../../Search/SearchContainer.jsx'
import {searchOffers} from '../../Search/actions.js'

class OfferSearchContainer extends Component {
  static searchRouteName = 'offers.search.results'

  search = (data) => {
    this.props.history.push(
      generate({
        name: OfferSearchContainer.searchRouteName,
        search: this.flattenSearchObject({
          ...data,
          page: 1,
        })
      })
    )
  }

  flattenSearchObject = (data) => {
    const {...output} = data

    if (isEmpty(output.city) && isEmpty(output.latitude) && isEmpty(output.longitude)) {
      delete output.city
      delete output.latitude
      delete output.longitude
    }

    delete output.target

    return output
  }

  expandSearchObject = (search, currentUniverseId) => {
    const {keywords, universe, page, ...output} = search
    if (!isEmpty(keywords)) {
      output.keywords = !Array.isArray(keywords) ? [keywords] : keywords
    }

    output.universe = (universe || currentUniverseId).toString()
    output.page = toPositiveIntString(page, 1)
    output.target = conf.search.targets.offers

    return output
  }

  render() {
    return (
      <SearchContainer
        expandSearchObject={this.expandSearchObject}
        flattenOffer={this.props.flattenOffer}
        flattenSearchObject={this.flattenSearchObject}
        hasSearchQueryChanged={this.hasSearchQueryChanged}
        liftOffer={this.props.liftOffer}
        search={this.search}
        routes={this.props.route.routes}
        dispatchSearch={this.props.searchOffers}
        searchRouteName={OfferSearchContainer.searchRouteName}
        searchTarget={conf.search.targets.offers}
      />
    )
  }
}

export default connect(
  (state) => ({
    search: state.search.search
  }),
  (dispatch) => ({
    searchOffers: (model) => dispatch(searchOffers(model))
  })
)(mustHaveAcceptedCGU(OfferSearchContainer))